import React from 'react';
import { observer, inject } from 'mobx-react';

import { Heading } from 'grommet';

import BookElement from 'app/api/bookElement';

import SectionBreak from 'app/components/BookElements/SectionBreak';
import TableOfContentsEntry from 'app/components/BookElements/TableOfContentsEntry';
import Paragraph from 'app/components/Paragraph';
import Anchor from 'app/components/Anchor';

class Information extends React.Component {
  render() {
    const { path } = this.props;
    if (BookElement.isNotSelected(path)) return null;

    return (
      <React.Fragment>
        <TableOfContentsEntry path={path}>
          <Heading responsive textAlign="center">
            Information
          </Heading>
        </TableOfContentsEntry>
        <Paragraph>
          The authenticated version of this publication is available at the Army
          Publication Directorate site (
          <Anchor href="http://www.apd.army.mil">
            http://www.apd.army.mil
          </Anchor>
          ), and the Central Army Registry site (
          <Anchor href="https://atiam.train.army.mil/catalog/dashboard">
            https://atiam.train.army.mil/catalog/dashboard
          </Anchor>
          )
        </Paragraph>
        <SectionBreak />
      </React.Fragment>
    );
  }
}

const Component = inject('AppState')(observer(Information));
Component.displayName = 'Information';
export const InformationComponent = Information;
export default Component;



// WEBPACK FOOTER //
// ./src/app/components/BookElements/Information.js